import React, { useState, useEffect } from "react";
import PublicCatalogLayout from "@/layouts/PublicCatalogLayout"
import { fetchAPI } from "@/utility/NetworkUtils";
import {
  DataGridPremium,
  renderBooleanCell
} from "@mui/x-data-grid-premium";
import DataGridTableToolbar from "@/utility/DataGridTableToolbar";
import { Link, Button, Tooltip, Stack } from "@mui/material";
import AddNewItemButton from "@/layouts/partials/headers/AddNewItemButton";
import { isJaguar } from "@/utility/UserUtils";
import DefaultTooltip from "@/layouts/tooltips/DefaultTooltip";
import DataGrid from "@/layouts/tables/DataGrid";
import CheckIcon from '@mui/icons-material/Check';
import ItemCardQuickViewModal from "@/items/ItemCardQuickViewModal";
const InventoryItemsDashboard = ({
  renter,
  
  user
}) => {
  const [ items, setItems ] = useState([]);
  const [ loading, setLoading ] = useState(false);
  const fetchItems = async () => {
    setLoading(true)
    fetchAPI(`/webapi/renters/${renter ? renter.id : "all"}/items`, (json)=> {
      if (!json.errors) {
        setItems(json.items)
        setLoading(false)
      } else {
        console.log({
          errors: json.errors
        })
      }
    })
  }

  useEffect(() => {
    fetchItems()
  }, [])

  const getItems = () => {
    return items.map(x=> {
      x.category_name = (x.category||{}).name || "Other";
      x.group_name = (x.category||{}).group_name || "Misc";
      x.image_url = x.active_image ? x.active_image.thumbnail_url : "";
      x.size = renderSubSizes(x)
      return x;
    })
  }

  const renderSize = (item) => {
    const dimensions = [item.product_width, item.product_height, item.product_length].filter(x=>x).map(x=>parseFloat(x))
    if(dimensions.length > 0) {
      let value = "";
      if(item.size_type) {
        value = dimensions.map(x=>x+'ft.').join(" x ")
      }else {
        value = dimensions.map(x=>x+'"').join(" x ")
      }
      return value
    }
  }

  const renderSubSizes = (item) => {
    const size = renderSize(item)
    if(item.apparel_size || item.apparel_gender){
      return [item.apparel_gender, item.apparel_size] .filter(x=>x).join(", ")
    }else if (size) {
      return size
    }
  }

  const renderBooleanCell = (params) => {
    return params.value ? <CheckIcon color="green"/> : null;
  }

    const renderInternalNotesCell = (params) => {
    return params.value ? <img src={'/images/table/internal_notes.svg'}/> : null;
  }


  const getColumns = () => {
    return [
      {field: "image_url", width: 60, maxWidth: 60, sorting: false, filtering: false, headerName: "Image", renderCell: (params) => (params.value ? <img alt={params.row.name+" Image"} loading="lazy" src={params.value} style={{width: "60px", height: "60px"}}/> : "")},
      {field: "name", flex: 2, headerName: "Name"},
      {
        field: "size", 
        flex: 1,
        headerName: "Specs",
      },
      {field: "owned", flex: 1, headerName: "Quantity"},
      {field: "group_name", flex: 1, headerName: "Category"},
      {field: "category_name", flex: 1, headerName: "Sub Category"},
      {field: "renter",flex: 1, headerName: "Owner", disabled: !!renter, valueGetter: (value) => {
        return (value||{name: "Jaguar Design Studio"}).name
      }},
      {
        field: "warehouse_location",
        flex: 1,
        headerName: "Warehouse Location",
        disabled: !isJaguar(user),
      },
      {field: "internal_notes",  headerName: "Internal Notes",width: 150,maxWidth: 150, type: "boolean", disabled: !isJaguar(user), renderCell: renderInternalNotesCell},
      {
        field: "rental_cost",
        flex: 1,
        headerName: "Rental Price",
        defaultInvisible: true,
        disabled: !isJaguar(user),
         renderCell: (params) => {
          if(!params.value || params.value == '0' || params.value == '0.00' || params.value == '0.0') {
            return ""
          }
          console.log({
            value: params.value
          })
          return "$"+((parseFloat(params.value)||0).toFixed(2))
        }
      },
      {
        field: "public",
        flex: 1,
        headerName: "Public View",
        type: "boolean",
        defaultInvisible: true,
        disabled: !isJaguar(user),
        renderCell: renderBooleanCell
      },
      
      {field: "audited_2025",  headerName: "Audit 2025",width: 100, maxWidth: 100, type: "boolean", disabled: !isJaguar(user), defaultInvisible: true, renderCell: renderBooleanCell},
      {field: "audited_2026",  headerName: "Audit 2026",width: 100,maxWidth: 100, type: "boolean", disabled: !isJaguar(user), renderCell: renderBooleanCell},
      {field: "actions",
        headerName: "Actions",
        type: "actions",
        
        flex: 1,
        minWidth: 200,
        maxWidth: 250,
        align: "right",
        renderCell: renderActions
      },
    ].filter(x => !x.disabled)
  }

  const fetchItem = () => {
    fetchAPI(`/webapi/items/${item.id}`, (json) => {
      if (!json.errors) {
        const itemIndex = items.findIndex(x=>x.id == item.id)
        if(itemIndex > -1) {
          setItems([
            ...items.slice(0, itemIndex),
            json,
            ...items.slice(itemIndex+1)
          ])
        }
      } else {
        console.log({
          errors: json.errors
        })
      }
    });
  }

  const renderActions = (params) => {
    return (
      <Stack direction="row" spacing={1}>
        <ItemCardQuickViewModal accessButton={(props)=> (
          <Link {...props}>
            View
          </Link>
        )} onClose={fetchItem} item={params.row} user={user}/>
      
        <Link
          
          href={`${getRenterUrlPrefix()}/${params.row.id}/edit`}>Edit</Link>
        <Link
          component="button"
          onClick={()=>deleteItem(params.row.id)} 
        >
          DELETE
        </Link>
        <Link
            size="small"
            variant="contained"
            color="primary"
            href={`${getRenterUrlPrefix()}/${params.row.id}/duplicate`}
          >
            Clone
          </Link>
      </Stack>
    )
  }

  const getRenterUrlPrefix = () => {
    if (renter) {
      return `/inventory/${renter.id}/items`
    } else {
      return "/management/items"
    }
  }

  const deleteItem = (id) => {
    if(confirm("Are you sure you want to delete this item? This cannot be undone.")) {
      fetchAPI(`/webapi/renters/${renter ? renter.id : "all"}/items/${id}`, (json)=> {
        if (!json.errors) {
          fetchItems()
        } else {
          alert(json.errors.join("\n"));
        }
      }, {
        method: "DELETE",
      })
    }
  }

  const renderLinkDivider = () => {
    return (
      <div className="inline-block px-[8px]">|</div>
    )
  }

  const renderInventoryLinks = () => {
    const linkClasses="text-blue-600 text-base font-normal"
    if(renter) {
      return (
        <div className={`pb-[20px] ${linkClasses}`}>
          <a className={linkClasses} href={`/warehouse/reports/renter_full_billing?id=${renter.id}`}>Download Inventory Report</a>
          {renderLinkDivider()}
          <a className={linkClasses} href={`/inventory/${renter.id}/categories/`}>Manage Categories</a> 
          {renderLinkDivider()}
          <a className={linkClasses} href={`/inventory/${renter.id}/item_tags/`}>Manage Tags</a>
        </div>
      )
    }else if(isJaguar(user)) {
      return (
        <div className={`pb-[20px] ${linkClasses}`}>
          <DefaultTooltip title="Under Construction" placement="top" arrow color="tooltip">
            <a className={linkClasses} href="#">Download Inventory Report</a>
          </DefaultTooltip>
          {renderLinkDivider()}
          <a className={linkClasses} href="/management/categories/">Manage Categories</a> 
          {renderLinkDivider()}
          <a className={linkClasses} href="/tags/">Manage Tags</a>
        </div>
      )
    }

  }

  const getDefaultColumnVisibility = () => {
    visibility = {}
    const columns = getColumns()
    columns.forEach((column) => {
      
      if (column.defaultInvisible) {
        visibility[column.field] = false
      }else {
        visibility[column.field] = true
      }

    })
    return visibility
  }

  const renderItemsTable = () => {
    return (
      <DataGrid
        tableName="management_items_3"
        sx={{
          "& .MuiDataGrid-columnHeaders": {
            position: "sticky",
            top: 64, // if your page has a 64px top navbar
            zIndex: 1000,
            backgroundColor: "white",
          },
          "& .MuiDataGrid-main": { 
            overflow: "visible"
          },
          "& .MuiDataGrid-virtualScroller": {
            overflow: "visible !important"
          },
          "& .MuiDataGrid-root": {
            overflow: "visible !important"
          }
        }}
        autoHeight={true}
        unstable_headerFilters
        rows={getItems()}
        columns={getColumns()}
        defaultColumnVisibility={getDefaultColumnVisibility()}
        loading={loading}
        slots={{
          toolbar: DataGridTableToolbar
        }}
        style={{
          cell: {
            paddingBottom: 0,
            paddingRight: 0,
            whiteSpace: 'normal',
            overflow: 'visible',
          },
          header: {
            postition: 'sticky',
            top: 64
          }
        }}
        pagination={true}
        pageSizeOptions={[50, 100]}
      />
   )
  }

  return (
    <PublicCatalogLayout
      classNames={{container: 'full-width-container'}}
      className="inventory-dashboard"
      renter={renter}
      currentPage={renter ? "inventory-"+renter.id : null}
      user={user}
      breadcrumbs={renter ? [
        {name: `${renter.name} Inventory`, url: `/inventory/${renter.id}`},
        {name: "Manage Inventory"}
      ] : [
        {name: "Inventory", url: "/"},
        {name: "Manage Inventory"}
      ]}
      disableGroups=  {true}
    >
      <div className="row">
        <div className="col-xs-12">
          <h1 className="catalog-h1" style={{marginBottom: "10px"}}>
            {renter ? renter.name+" Inventory Management" : "Inventory Management"}
            <div
            className="catalog-h1-float-right"
            >
              <AddNewItemButton user={user} renter={renter} items={items} /> 
            </div>
          </h1>
        </div>
        <div className="col-xs-12">
          <div className="inventory-links">
            {renderInventoryLinks()}
          </div>
        </div>
      </div>
      {renderItemsTable()}
    </PublicCatalogLayout>
  );
}

export default InventoryItemsDashboard